<template>
    <div class="noresults-container container" v-if="this.totelements==0 && this.action=='init'">
        <div class="message-box row">
        <span v-html="this.assets.alertBoxNoDateLP">
        </span>
            <a class="btn btn-primary btn-prenotazioni" target="_blank" v-bind:href="this.caseurl" v-if="this.layout=='big' && this.origin == 'PDP'">Contattaci</a>
        </div>
    </div>

    <template v-else>
        <p v-if="layout === 'big'" class="lp-subtitle">Le date e i prezzi si riferiscono a <b>partenze da {{this.geocodemob ? this.geocodemob : this.geocodemodel }}.</b> Cambia la città per aggiornare la lista delle partenze.</p>
        <div class="lp-header">
            <form class="city-search-form">
                <div class="container-md container-form" v-if="this.layout=='big'">
                    <div class="container-search-info">
                        <p class="d-lg-none search-city-mob">{{this.geocodemob ? this.geocodemob : this.geocodemodel }}</p>
                    </div>
                    <div class="row m-0 align-items-center">
                        <div class="container-search-field col-lg-10 pl-md-0 d-lg-block d-none">
                            <input type="text" class="form-control" id="search-field" autocomplete="off" v-model="this.geocodemodel" @input="geocodeInput()" @focusin="this.geocodes.length ? this.suggestionsdisplay = $event.target.value.trim() != '' : '' " @focusout="this.focusoutSuggestions()" v-bind:placeholder="translations.searchBar.placeholder">
                            <span class="icon icon-search-alt"></span>
                            <div class="container-blocks pl-3 pr-3"><span class="search-field-linee mr-3"></span></div>
                            <div class="suggestions-geocodes" v-if="!this.matchMedia.md" v-bind:class="toggleSuggestions">
                                <ul class="suggestions-results" role="listbox">
                                    <template v-for="(geocode, index) in this.geocodes">
                                        <li class="suggestions-item" v-if="index < this.numgeocodes" v-on:click="setGeocodeToApply([geocode.geoname_id,geocode.geoname_desc])">
                                            <div class="suggestions-item-container">
                                                <img class="item-img" :src="this.icons.citta">
                                                <div class="item-info">
                                                    <span class="item-name">{{geocode.geoname_desc}}</span>
                                                    <span class="item-category">{{translations.searchBar.suggestion.label}}</span>
                                                </div>
                                            </div>
                                        </li>
                                    </template>
                                </ul>
                            </div>
                        </div>
                        <div class="container-search-btn col-12 col-lg-2">
                            <button type="button" class="btn btn-secondary cta-modify" v-on:click="this.matchMedia.lg ? this.toggleSubFilters('geocodes') : initGeocode()">{{this.matchMedia.lg ? translations.searchBar.button : translations.searchBar.buttonbig}}</button>
                            <button type="button" class="btn btn-outline-secondary d-lg-none cta-order" v-on:click="this.toggleSubFilters('ordersmob')">{{translations.filterBar.button.order}}</button>
                        </div>
                    </div>
                </div>

                <template v-if="this.layout=='small' && this.origin == 'PDPDP'">
                    <div class="container-form">
                        <div class="container-search-info">
                            <label for="search-field">{{translations.searchBar.label2}}</label>
                            <p class="search-city-mob">{{this.geocodemob ? this.geocodemob : this.geocodemodel }}</p>
                        </div>
                        <div class="container-search-btn">
                            <button type="button" class="btn btn-secondary" v-on:click="this.toggleSubFilters('geocodes')">{{translations.searchBar.button}}</button>
                        </div>
                    </div>
                </template>
            </form>
        </div>

        <div class="alerts-container" v-bind:class="this.layout=='big'?'container-md':''">
            <template v-for="(alert, index) in this.alerts">
                <div class="alert fade" v-bind:class="this.getAlerts(alert) ? alert + ' show' : ''" role="alert">
                  <span v-if="alert == 'others'" class="icon icon-info">&nbsp {{translations.alerts[alert]}}</span>
                  <span v-else>{{translations.alerts[alert]}}</span>
                    <button type="button" class="btn" v-on:click="this.getAlerts(alert) ? this.setAlerts(alert) : ''">
                        <span class="icon icon-cancel"></span>
                    </button>
                </div>
            </template>
        </div>
        <div class="departure-filters" v-if="layout === 'big'">
                  <!-- Filtri Anno -->
                  <div class="filter-year">
                    <button
                      v-for="year in availableYears"
                      :key="year"
                      :class="{ active: selectedYear === year }"
                      @click="toggleYear(year)">
                      {{ year }}
                    </button>
                  </div>

                  <!-- Filtri Mese (dipendenti dall’anno selezionato) -->
                  <div class="filter-month">
                    <button class="monthbutton"
                      v-for="month in monthsInSelectedYear"
                      :key="month.key"
                      :disabled="!month.enabled"
                      :class="{ active: selectedMonth === month.key, disabled: !month.enabled }"
                      @click="month.enabled && toggleMonth(month.key)">
                      {{ month.label }}
                    </button>
                  </div>
              </div>
        <div class="container-content" v-bind:class="this.layout == 'big' ? 'container-md' : ''">
            <div class="main-content" v-bind:class="'layout-'+this.layout">

                <div class="filters-mob" v-if="this.matchMedia.lg || (this.layout == 'small' && this.origin == 'PDPDP')" v-bind:class="[this.subFiltersOpened.style ? this.subFiltersOpened.style+' open' : '', this.origin == 'PDPDP' ? 'filters-opened-always' : 'filters-opened-mob']">
                    <div class="filterssub-head" v-if="this.subFiltersOpened" >
                        <div class="container-head" v-bind:class="(this.layout == 'small' && this.origin == 'PDPDP') ? 'container-sm pl-0 pr-0' : ''">
                            <button class="btn btn-return" v-on:click="this.toggleSubFilters()"><span class="icon icon-return" v-bind:class="this.subFiltersOpened.returnicon"></span></button>
                            <div class="title-bar">{{this.subFiltersOpened.title}}</div>
                        </div>
                    </div>

                    <div class="filterssub-body" v-bind:class="(this.layout == 'small' && this.origin == 'PDPDP') ? 'container-sm pl-0 pr-0' : ''">

                        <div class="container-orders" v-if="this.subFiltersOpened.type=='ordersmob'">
                            <p>Ordina per</p>
                            <form class="orders-form" name="orders-form">
                                <ul>
                                    <li v-on:click="this.mobordine='partenza'"><input type="radio" id="partenza-ordermob" name="ordermob"><label for="partenza-ordermob">Partenza</label></li>
                                    <li v-on:click="this.mobordine='prezzo'"><input type="radio" id="prezzo-ordermob" name="ordermob"><label for="prezzo-ordermob">Prezzo</label></li>
                                </ul>
                            </form>
                        </div>

                        <div class="container-search-field" v-if="this.subFiltersOpened.type=='geocodes'">
                            <input type="text" class="form-control inputext-filter" v-if="this.subFiltersOpened.type=='geocodes'" autocomplete="off" v-model="this.geocodemodel" @input="geocodeInput()" v-bind:placeholder="translations.searchBar.placeholder">
                            <span class="icon icon-search-alt"></span>
                        </div>

                        <div class="suggestions-geocodes" v-if="this.subFiltersOpened && this.subFiltersOpened.type=='geocodes'" v-bind:class="toggleSuggestions">
                            <ul class="suggestions-results" role="listbox">
                                <template v-for="(geocode, index) in this.geocodes">
                                    <li class="suggestions-item" v-if="index < this.numgeocodes" v-bind:class="this.geocodeToApply[0]==geocode.geoname_id && this.geocodeToApply[1]==geocode.geoname_desc ? 'selected' : ''" v-on:click="setGeocodeToApply([geocode.geoname_id,geocode.geoname_desc])">
                                        <div class="suggestions-item-container">
                                            <div class="item-container">
                                                <img class="item-img" :src="this.icons.citta">
                                                <div class="item-info">
                                                    <span class="item-name">{{geocode.geoname_desc}}</span>
                                                    <span class="item-category">{{translations.searchBar.suggestion.label}}</span>
                                                </div>
                                            </div>
                                            <span class="icon icon-checked item-checked"></span>
                                        </div>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>

                    <div class="filterssub-footer" v-if="this.subFiltersOpened" >
                        <button class="btn btn-secondary filterssub-cta" v-bind:class="[this.subFiltersOpened.type+'-cta', (this.layout == 'small' && this.origin == 'PDPDP') ? 'cta-maxw' : '']" v-on:click="this.subFiltersOpened.ctaFN">
                            {{ this.subFiltersOpened.cta }}
                        </button>
                    </div>

                </div>

                <div class="results-container" v-bind:class="this.layout == 'small' ? 'p-0' : ''">

                    <div class="results">

                        <div class="table-responsive" v-if="!this.matchMedia.lg">
                            <template v-if="layout === 'big'" v-for="(departures, meseAnno,index) in limitedGroupedDepartures" :key="meseAnno">
                              <div v-if="layout === 'big'" class="month-header month-label-status">
                                <h4 v-if="!selectedMonth" class="month-title">
                                  {{ formatMonthLabel(meseAnno, 'long') }}
                                </h4> 
                                <h4 v-else class="month-title placeholder"></h4>
                                <span v-if="index === 0" class="th-label-status" v-on:click="this.openModal('travel-status')">{{ 'Cosa significa lo status del mio viaggio?' }}</span>                               
                              </div>
                              <table class="table">
                                  <thead v-if="this.layout=='big'">
                                  <tr>
                                      <th scope="col" v-on:click="applyFilter('ordinamento', 'data_', 'paginationorder-reset')"><span class="icon icon-order icon-arrow-order asc"
                                       :class="{
                                        asc: sortKey === 'data_partenza' && sortOrder === 'asc',
                                        desc: sortKey === 'data_partenza' && sortOrder === 'desc'
                                      }" @click="sortBy('data_partenza')" style="cursor: pointer;"></span>{{ translations.tab.startdate.header }}</th>
                                      <th scope="col">{{ translations.tab.days.header }}</th>
                                      <th scope="col">{{ translations.tab.nations.header }}</th>
                                      <th scope="col">{{ translations.tab.name.header }}</th>
                                      <th scope="col">{{ translations.tab.type.header }}</th>
                                      <th scope="col">{{ translations.tab.formula.header }}</th>
                                      <th scope="col">{{ translations.tab.status.header }}</th>
                                      <th scope="col" class="col-prezzo" v-on:click="applyFilter('ordinamento', 'prezzo_', 'paginationorder-reset')"><span class="icon icon-order icon-arrow-order asc"
                                      :class="{
                                        asc: sortKey === 'prezzo' && sortOrder === 'asc',
                                        desc: sortKey === 'prezzo' && sortOrder === 'desc'
                                      }" @click="sortBy('prezzo')" style="cursor: pointer;"></span>{{ translations.tab.price.header }}</th>
                                  </tr>
                                  </thead>
                                  <template v-for="(element, index) in departures">
                                      <tbody v-if="((index < (this.origin == 'PDP' ? 3 : 1)) && this.layout=='small') || this.layout=='big'">
                                      <tr class="row-main" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'"
                                      >
                                          <td class="font-weight-bold text-nowrap datapartenza">{{ this.getDataPartenza(element.data_partenza) }}</td>
                                          <td class="text-nowrap" v-if="this.layout=='big'">{{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}</td>
                                          <td class="font-weight-bold text-uppercase" v-if="this.layout=='big'">
                                              <div v-for="(nazione) in element.nazioni">
                                                  {{ nazione }}
                                              </div>
                                          </td>
                                          <td class="nome-viaggio font-weight-bold" v-if="this.layout=='big'">{{ element.nome_viaggio }}</td>
                                          <td class="font-weight-bold text-uppercase text-nowrap" v-if="this.layout=='big'" >{{ element.tipo_viaggio ? element.tipo_viaggio : translations.tab.type.value.VIAGGIOGUIDATO }}</td>
                                          <td class="with-separator">{{ translations.tab.formula.value[element.formula_viaggio] }}</td>
                                          <td class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''"><div class="container-with-separator">{{ translations.tab.status.value[element.cod_disponibilita] }}<button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button></div></td>
                                          <td class="with-separator prezzo text-right">
                                              <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                                              {{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span>
                                          </td>
                                          <td class="text-right cta">
                                              <a href="#" class="btn btn-primary btn-viaggio" v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})">
                                                  {{ translations.tab.buttons.book }}
                                              </a>
                                          </td>
                                      </tr>
                                      </tbody>
                                  </template>
                              </table>
                            </template>
                            <div
                                v-if="layout === 'big' && !showAllDepartures && Object.values(groupedDepartures).flat().length > maxVisibleDepartures"
                                class="text-center mt-3"
                              >
                                <button @click="showAllDepartures = true" class="btn btn-gold">
                                  MOSTRA ALTRE PARTENZE
                                </button>
                              </div>
                            <template v-if="layout === 'small'" v-for="(element, index) in flattenedDepartures.slice(0, 3 )">
                                  <table class="table">
                                    <tbody v-if="((index < (this.origin == 'PDP' ? 3 : 1)) && this.layout=='small') || this.layout=='big'">
                                      <tr class="row-main" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'"
                                      >
                                          <td class="font-weight-bold text-nowrap datapartenza">{{ this.getDataPartenza(element.data_partenza) }}</td>
                                          <td class="text-nowrap" v-if="this.layout=='big'">{{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}</td>
                                          <td class="font-weight-bold text-uppercase" v-if="this.layout=='big'">
                                              <div v-for="(nazione) in element.nazioni">
                                                  {{ nazione }}
                                              </div>
                                          </td>
                                          <td class="nome-viaggio font-weight-bold" v-if="this.layout=='big'">{{ element.nome_viaggio }}</td>
                                          <td class="font-weight-bold text-uppercase text-nowrap" v-if="this.layout=='big'" >{{ element.tipo_viaggio ? element.tipo_viaggio : translations.tab.type.value.VIAGGIOGUIDATO }}</td>
                                          <td class="with-separator">{{ translations.tab.formula.value[element.formula_viaggio] }}</td>
                                          <td class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''"><div class="container-with-separator">{{ translations.tab.status.value[element.cod_disponibilita] }}<button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button></div></td>
                                          <td class="with-separator prezzo text-right">
                                              <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                                              {{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span>
                                          </td>
                                          <td class="text-right cta">
                                              <a href="#" class="btn btn-primary btn-viaggio" v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})">
                                                  {{ translations.tab.buttons.book }}
                                              </a>
                                          </td>
                                      </tr>
                                      </tbody>
                                    </table>
                                  </template>
                        </div>

                        <div class="box-mobile" v-if="this.matchMedia.lg">
                            <a
                              href="#"
                              style="text-decoration:underline;display:block;text-align:center;margin:10px auto 10px auto;"
                              v-on:click="this.openModal('travel-status')"
                            >
                              {{ 'Cosa significa lo status del mio viaggio?' }}
                            </a>
                            <template v-if="layout === 'big'" v-for="(departures, meseAnno) in limitedGroupedDepartures" :key="meseAnno">


                              <div class="month-header">
                                <h4 class="month-title" v-if="layout === 'big' && !selectedMonth">
                                  {{ formatMonthLabel(meseAnno, 'long') }}
                                </h4>
                                <h4 class="month-title" v-else>&nbsp;</h4>
                              </div>

                                <template v-for="(element, index) in departures">
                                  <div class="itembox" v-if="(index < 1 && this.layout=='small') || this.layout=='big'" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'">
                                      <div class="row">
                                          <div class="col-6 col-left"><span class="font-weight-bold">{{ this.getDataPartenza(element.data_partenza) }}</span> <span class="lineebreak"></span> {{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}</div>
                                          <div class="col-6 col-right">
                                              <div class="font-weight-bold text-uppercase" v-for="(nazione) in element.nazioni">
                                                  {{ nazione }}
                                              </div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-12">{{ element.nome_viaggio }}</div>
                                      </div>
                                      <div class="row">
                                          <div class="col-6 col-left">
                                              <div class="font-weight-bold text-uppercase">{{ element.tipo_viaggio ? element.tipo_viaggio : translations.tab.type.value.VIAGGIOGUIDATO }}</div>
                                              <div class="font-weight-bold text-uppercase eta" v-if="false">ETA' 45-55</div>
                                          </div>
                                          <div class="col-6 col-right">{{ translations.tab.formula.value[element.formula_viaggio] }}</div>
                                      </div>
                                      <div class="row">
                                          <div class="col-6 col-left">
                                              <div class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''">{{ translations.tab.status.value[element.cod_disponibilita] }}</div>
                                              <div><button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button></div>
                                          </div>
                                          <div class="col-6 col-right">
                                              <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                                              <div class="actual-price">{{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span></div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div v-bind:class="this.layout=='big' ? 'col-12' : 'col-7 col-sm-9 col-md-10 col-left'">
                                              <a href="#" class="btn btn-primary w-100 btn-viaggio" v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})">
                                                  {{ translations.tab.buttons.book }}
                                              </a>
                                          </div>
                                          <div class="col pl-0 justify-content-end col-right" v-if="this.layout=='small'">
                                              <a v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})" class="btn btn-link pl-0 link-preventivo">{{ translations.tab.buttons.quotation }}
                                                  <span class="icon icon-arrow-preventivo icon-arrow-order"></span>
                                              </a>
                                          </div>
                                      </div>
                                      <div class="row" v-if="element.informazioni_bbk['note'] && this.userisbbk!=='false'">
                                          <div class="note-bbk col col-left" v-if="true">
                                              <span class="label-note">NOTE INTERNE:</span> <span class="info-note">{{ !element.informazioni_bbk ? '' : element.informazioni_bbk['note'] ? element.informazioni_bbk['note'] : '' }}</span>
                                          </div>
                                      </div>
                                  </div>
                                </template>
                            </template>
                            <div
                                v-if="layout === 'big' && !showAllDepartures && Object.values(groupedDepartures).flat().length > maxVisibleDepartures"
                                class="text-center mt-3"
                              >
                                <button @click="showAllDepartures = true" class="btn btn-gold">
                                  MOSTRA ALTRE PARTENZE
                                </button>
                              </div>
                            <template v-if="layout === 'small'" v-for="(element, index) in flattenedDepartures.slice(0, 1 )">
                                <div class="itembox" v-if="(index < 1 && this.layout=='small') || this.layout=='big'" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'success-row' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'danger-row' : 'default-row'">
                                      <div class="row">
                                          <div class="col-6 col-left"><span class="font-weight-bold">{{ this.getDataPartenza(element.data_partenza) }}</span> <span class="lineebreak"></span> {{ element.durata }} {{ parseInt(element.durata) == 1 ? translations.tab.days.day :  translations.tab.days.days }}</div>
                                          <div class="col-6 col-right">
                                              <div class="font-weight-bold text-uppercase" v-for="(nazione) in element.nazioni">
                                                  {{ nazione }}
                                              </div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div class="col-12">{{ element.nome_viaggio }}</div>
                                      </div>
                                      <div class="row">
                                          <div class="col-6 col-left">
                                              <div class="font-weight-bold text-uppercase">{{ element.tipo_viaggio ? element.tipo_viaggio : translations.tab.type.value.VIAGGIOGUIDATO }}</div>
                                              <div class="font-weight-bold text-uppercase eta" v-if="false">ETA' 45-55</div>
                                          </div>
                                          <div class="col-6 col-right">{{ translations.tab.formula.value[element.formula_viaggio] }}</div>
                                      </div>
                                      <div class="row">
                                          <div class="col-6 col-left">
                                              <div class="text-uppercase" v-bind:class="element.cod_disponibilita == 'CONFERMATO' ? 'font-weight-bold' : element.cod_disponibilita == 'ULTIMIPOSTI' ? 'font-weight-bold danger-col' : ''">{{ translations.tab.status.value[element.cod_disponibilita] }}</div>
                                              <div><button class="btn btn-link btn-avviso" v-if="element.cod_disponibilita == 'QUASICONFERMATO' || element.cod_disponibilita == 'PROGRAMMATO'" v-on:click="this.openModal('confirmation-alert',confirmationModalData(element,this.userdata))"><span>{{ translations.tab.status.notify }}</span> {{ translations.tab.status.note }}</button></div>
                                          </div>
                                          <div class="col-6 col-right">
                                              <div class="font-weight-bold prezzo-scontato" v-if="element.prezzo_scontato">{{ '€ ' + $filters.formatPriceFilter(element.prezzo) }}</div>
                                              <div class="actual-price">{{ translations.tab.price.from }} <span class="font-weight-bold">{{ $filters.formatPriceFilter(element.prezzo_scontato) || $filters.formatPriceFilter(element.prezzo)}}</span></div>
                                          </div>
                                      </div>
                                      <div class="row">
                                          <div v-bind:class="this.layout=='big' ? 'col-12' : 'col-7 col-sm-9 col-md-10 col-left'">
                                              <a href="#" class="btn btn-primary w-100 btn-viaggio" v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})">
                                                  {{ translations.tab.buttons.book }}
                                              </a>
                                          </div>
                                          <div class="col pl-0 justify-content-end col-right" v-if="this.layout=='small'">
                                              <a v-on:click="this.openModal('select-city',{confirmUrl : this.spapurl+'?geonameid_code='+this.geoname+'&pratica_cod='+element.preno_cod+'&prezzo_base_mezza_doppia='+element.prezzo+'&sottoprogramma_cod='+element.cod_sottoprogramma})" class="btn btn-link pl-0 link-preventivo">{{ translations.tab.buttons.quotation }}
                                                  <span class="icon icon-arrow-preventivo icon-arrow-order"></span>
                                              </a>
                                          </div>
                                      </div>
                                      <div class="row" v-if="element.informazioni_bbk['note'] && this.userisbbk!=='false'">
                                          <div class="note-bbk col col-left" v-if="true">
                                              <span class="label-note">NOTE INTERNE:</span> <span class="info-note">{{ !element.informazioni_bbk ? '' : element.informazioni_bbk['note'] ? element.informazioni_bbk['note'] : '' }}</span>
                                          </div>
                                      </div>
                                  </div>
                            </template>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </template>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import * as moment from 'moment';
import 'moment/locale/it';

moment.locale('it');

export default {
    props: [
        'dataurl',
        'geocodeurl',
        'caseurl',
        'spapurl',
        'producturl',
        'notifyurl',
        'iconsuggestions',
        'queryinit',
        'userisbbk',
        'assetsurl',
        'trans',
        'layout',
        'standalone',
        'userdata',
        'origin'
    ],
  data() {
    return {
      timer: 0,
      suggestionsdisplay: false,
      geocodemodel: '-',
      geocodemob: '',
      geocodeToApply: [],
      destinationmodel: '',
      destinationmob: [],
      destinationsdisplay: false,
      ordermob: [],
      mobordine: 'partenza',
      subFiltersOpened: false,
      startDateFinal: null,
      endDateFinal: null,
      matchMedia: {lg:null, md:null, sm:null},
      selectedYear: null,
      selectedMonth: null,
      showAll: false,
      showAllDepartures: false,
      maxVisibleDepartures: 15,
      sortKey: 'data_partenza',
      sortOrder: 'asc'
    }
  },
    computed: {
        ...mapState([
            'url',
            'elements',
            'elementsfirstpage',
            'geocodes',
            'destinations',
            'numgeocodes',
            'filters',
            'filtersActive',
            'filtersToApply',
            'paginationOrderActive',
            'totPage',
            'isFiltersColOpen',
            'geoname',
            'datepickerpresetsrange',
            'translations',
            'icons',
            'totelements',
            'alerts',
            'action',
            'assets'
        ]),
        limitedGroupedDepartures() {
          let all = [];

          Object.keys(this.groupedDepartures).forEach(key => {
            this.groupedDepartures[key].forEach(dep => {
              all.push({ key, ...dep });
            });
          });

          all.sort((a, b) => {
            let valA = a[this.sortKey];
            let valB = b[this.sortKey];

            // Se è una data, la trasformo
            if (this.sortKey === 'data_partenza') {
              valA = new Date(valA);
              valB = new Date(valB);
            } else {
              // Faccio parsing numerico se è prezzo
              valA = parseFloat(valA);
              valB = parseFloat(valB);
            }

            const result = valA > valB ? 1 : valA < valB ? -1 : 0;
            return this.sortOrder === 'desc' ? result : -result;
          });

          const limited = this.showAllDepartures ? all : all.slice(0, this.maxVisibleDepartures);

          return limited.reduce((acc, item) => {
            if (!acc[item.key]) acc[item.key] = [];
            acc[item.key].push(item);
            return acc;
          }, {});
        },
        groupedDepartures() {
          const list = Array.isArray(this.elements) ? this.elements : [];

          const filtered = list.filter(dep => {
            const date = new Date(dep.data_partenza);
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const key = `${month}/${year}`;

            // Filtra per anno e mese se selezionati
            if (this.selectedYear && year !== this.selectedYear) return false;
            if (this.selectedMonth && key !== this.selectedMonth) return false;

            return true;
          });

          const map = new Map();

          filtered.forEach(dep => {
            const date = new Date(dep.data_partenza);
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            const key = `${month}/${year}`;

            if (!map.has(key)) map.set(key, []);
            map.get(key).push(dep);
          });

          const sortedEntries = Array.from(map.entries()).sort(([a], [b]) => {
            const [ma, ya] = a.split('/').map(Number);
            const [mb, yb] = b.split('/').map(Number);
            return new Date(ya, ma - 1) - new Date(yb, mb - 1);
          });

          return Object.fromEntries(sortedEntries);
        },
        flattenedDepartures() {
          const all = [];
          Object.values(this.groupedDepartures).forEach(monthGroup => {
            all.push(...monthGroup);
          });
          return all.sort((a, b) => new Date(a.data_partenza) - new Date(b.data_partenza));
        },
        visibleDepartures() {
          const all = this.$store.state.elements || [];

          // Se l’utente ha cliccato "vedi tutte", mostriamo tutto
          if (this.showAllDepartures) return all;

          // Altrimenti limitiamo a 15
          return all.slice(0, 15);
        },
        availableYears() {
          const allElements = this.$store.state.elementsfirstpage?.elements || [];
          const years = [...new Set(allElements.map(e => new Date(e.data_partenza).getFullYear()))];
          return years.sort((a, b) => a - b);
        },
        monthsInSelectedYear() {
          const source = this.$store.state.elementsfirstpage?.elements || [];
          const monthsWithDepartures = new Set();
          const now = new Date();

          // Raccogli i mesi con partenze
          source.forEach(dep => {
            const date = new Date(dep.data_partenza);
            if (date.getFullYear() === this.selectedYear) {
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const key = `${month}/${this.selectedYear}`;
              monthsWithDepartures.add(key);
            }
          });

          // Crea l’elenco completo dei mesi dell’anno selezionato
          const allMonths = [];
          for (let m = 1; m <= 12; m++) {
            const monthStr = String(m).padStart(2, '0');
            const key = `${monthStr}/${this.selectedYear}`;
            const label = this.formatMonthLabel(key, 'short');

            const enabled = monthsWithDepartures.has(key);
            allMonths.push({
              key,
              label,
              enabled
            });
          }

          return allMonths;
        },
        getFiltersApplied() {
          if(Object.keys(this.filtersActive).length) {
            var filtersActiveOrigin = JSON.parse(JSON.stringify(this.filtersActive));
            if(filtersActiveOrigin.data_da){
              filtersActiveOrigin.date = filtersActiveOrigin.data_da+'a'+filtersActiveOrigin.data_a;
              delete filtersActiveOrigin.data_da;
              delete filtersActiveOrigin.data_a;
            }
            var arrayFiltersActive = decodeURI($.param(filtersActiveOrigin)).replaceAll('[]','').split("&");
            if(this.matchMedia.lg){
              arrayFiltersActive = arrayFiltersActive.filter(x => !this.filtersToApply.includes(x));
            }
            //cconsole.log('QUAAAAA',decodeURI($.param(filtersActiveOrigin)).replaceAll('[]','').split("&"));
            return arrayFiltersActive;
          }
          return [];
        },
        toggleSuggestions(){
            return this.suggestionsdisplay ? '':'d-none';
        },
        toggleDestinations(){
          return this.destinationsdisplay ? '':'d-none';
        },
    },
    watch: {
      selectedYear() {
        this.showAllDepartures = false;
        this.sortKey = 'data_partenza';
        this.sortOrder = 'asc';
        this.sortBy('data_partenza');
      },
      // whenever question changes, this function will run
      geocodes(newGeocodes, oldGeocodes) {
        if ((this.geocodemodel == '-' && newGeocodes.length == 1 && this.origin == 'PDP' && this.layout == 'big') || (this.geocodemodel == '-' && newGeocodes.length == 1 && this.origin == 'PDPDP' && this.layout == 'small')) {
          this.geocodemodel = newGeocodes[0].geoname_desc;
          this.setSelectedCity(newGeocodes[0].geoname_desc);
          this.setGeocodes({});
        }
      },
      availableYears(newYears) {
        if (newYears.length === 1) {
          this.selectedYear = newYears[0];
        } else if (!this.selectedYear || !newYears.includes(this.selectedYear)) {
          this.selectedYear = newYears[0]; // o null, a seconda del comportamento desiderato
        }
      },
      elements(newElements, oldElements) {

        if (newElements.length && oldElements.length && this.origin == 'PDPDP') {
          var newData;
          var newSottoprogramma;
          if (newElements[0].data_partenza_timestamp != oldElements[0].data_partenza_timestamp) {
            newData = newElements[0].data_partenza.split('T')[0];
          }
          if (newElements[0].cod_sottoprogramma != oldElements[0].cod_sottoprogramma) {
            newSottoprogramma = newElements[0].cod_sottoprogramma;
          }
          if (newData || newSottoprogramma) {
            var newBase = window.location.search.split('-')[0];
            var newVariant = newBase + '-' + (newSottoprogramma ? newSottoprogramma : oldElements[0].cod_sottoprogramma) + '_' + (newData ? newData : oldElements[0].data_partenza.split('T')[0]);
            window.location.href = newVariant;
          }
        }
        if (this.layout == 'small') {
          if(this.getAlerts('convergents'))
            this.setAlerts('convergents');//reset Alerts 'convergents'
          if(this.getAlerts('others'))
            this.setAlerts('others');//reset Alerts 'others's'
          if(this.getAlerts('nodepartures'))
            this.setAlerts('nodepartures');//reset Alerts 'nodepartures'

          if (this.elementsfirstpage.geoname !== this.geoname) {
            if(newElements.length > 0) {
              if (newElements.length === this.elementsfirstpage.elements.length) {
                var convergents = true;
                for (var i = 0; i < this.elementsfirstpage.elements.length; i++) {
                  if (this.elementsfirstpage.elements[i].data_partenza_timestamp != newElements[i].data_partenza_timestamp) {
                    convergents = false;
                    break;
                  }
                }
                if (convergents)
                  this.setAlerts('convergents');
              }

              if (!this.getAlerts('convergents'))
                this.setAlerts('others');
            }else{

              this.setAlerts('nodepartures');

            }
            this.setElementsFirstPage({geoname: this.geoname, elements: this.elements});
          }

        }
      },
    },
    methods: {
        ...mapActions([
            'setFiltersColStatus',
            'setApplyFilter',
            'exeFilters',
            'setURI',
            'setDatepicker',
            'setGeocodes',
            'setDestinations',
            'setAssets',
            'setActiveFilters',
            'setActivePaginationOrder',
            'getResponseAPI',
            'getSelectedCity',
            'removeFilters',
            'setModal',
            'setTrans',
            'setIcons',
            'setInfoBreakpoints',
            'setGeoname',
            'setAlerts',
            'setSelectedCity',
            'setElementsFirstPage'
        ]),
      init() {
        if(this.standalone!='null' || this.layout=='small') {

          this.setURI([this.dataurl, this.geocodeurl, null, this.spapurl, this.assetsurl, this.producturl, this.notifyurl]);
          this.setTrans(JSON.parse(this.trans));
          this.setIcons(JSON.parse(this.iconsuggestions));
          if (this.queryinit !== 'null') {
            var paginationOrderIds = ['record_per_pagina', 'pagina', 'ordinamento'];
            var h = decodeURI(this.queryinit).split('&');
            var filtersApplied = {};
            var paginationOrderApplied = {};
            for (var i = 0; i < h.length; i++) {
              var hh = h[i].split('=');
              if (paginationOrderIds.indexOf(hh[0]) != -1) {
                paginationOrderApplied[hh[0]] = hh[1];
              } else if (hh[0] == 'id_geoname' || hh[0] == 'data_da' || hh[0] == 'data_a')
                filtersApplied[hh[0]] = hh[1];
              else if (hh[0] == 'layout' || hh[0] == 'origin' || hh[0] == 'standalone')
                continue;
              else if (filtersApplied[hh[0]])
                filtersApplied[hh[0]].push(hh[1]);
              else
                filtersApplied[hh[0]] = [hh[1]];
            }

            if (!paginationOrderApplied['record_per_pagina'])
              paginationOrderApplied['record_per_pagina'] = this.paginationOrderActive['record_per_pagina'];

            var filtersInit = Object.assign(JSON.parse(JSON.stringify(paginationOrderApplied)), filtersApplied);

            if (!filtersInit['id_geoname'])
              filtersInit['id_geoname'] = this.getCookie('idgeocode') ? this.getCookie('idgeocode') : '3173435';//Inizializzazione o con il cookie (geocode precedentemente scelto in sessione) o con Milano

            this.getResponseAPI({url: 'geocode', action: 'init', param: {q: filtersInit['id_geoname']}});//si unisce alla logica sul watch

            delete filtersApplied['id_geoname'];// Cancello perchè non deve fare parte degli ActiveFilters ma ha una parametro a se

            this.getResponseAPI({url: 'data', action: 'init', param: filtersInit});
            //console.log('filtersApplied', filtersApplied);
            this.setActiveFilters(filtersApplied);

            this.setActivePaginationOrder(paginationOrderApplied);

          } else {

            this.getResponseAPI({
              url: 'data',
              action: 'init',
              param: {id_geoname: '3173435', record_per_pagina: 200}
            });
          }

          this.getResponseAPI({url: 'assets', action: 'init'});
        }
      },
      sortBy(key) {
        if (this.sortKey === key) {
          // Inverte l’ordine
          this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
        } else {
          // Cambia chiave, resetta ordine
          this.sortKey = key;
          this.sortOrder = 'desc';
        }
      },
      formatMonthLabel(key, format = 'short') {
        const [monthStr, year] = key.split('/');
        const monthLabelsFull = [
          'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno',
          'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'
        ];
        const monthLabelsShort = [
          'GEN', 'FEB', 'MAR', 'APR', 'MAG', 'GIU',
          'LUG', 'AGO', 'SET', 'OTT', 'NOV', 'DIC'
        ];

        const monthIndex = parseInt(monthStr, 10) - 1;

        return format === 'short'
          ? monthLabelsShort[monthIndex]
          : `${monthLabelsFull[monthIndex]} ${year}`;
      },
       toggleYear(year) {

          if (this.selectedYear === year && this.selectedMonth) {
            // Se è già selezionato e c'è un mese selezionato, deseleziona il mese per tornare alla vista completa dell’anno
            this.selectedMonth = null;
          } else {
            // Cambio anno normalmente
            this.selectedYear = year;
            this.selectedMonth = null;
          }
        },
        toggleMonth(monthKey) {
          this.selectedMonth = this.selectedMonth === monthKey ? null : monthKey;
        },
        initGeocode(){
          if(this.geocodeToApply.length) {
            this.setGeoname(this.geocodeToApply[0]);
            this.setSelectedCity(this.geocodeToApply[1]);
            this.exeFilters({paginaReset: true});
            this.setCookie('idgeocode',this.geocodeToApply[0]);

            //if (this.matchMedia.lg)
              this.geocodemob = this.geocodeToApply[1];
            //this.geocodeToApply = [];
            //this.setActiveFilters({});//resetto i filtri
          }
        },
        getDataPartenza(date) {
            var parsedDate = moment(date);
            return parsedDate.format('D MMM YYYY');
        },
        toggleSubFilters(type) {
          var bar = {style : 'bar-style', returnicon: 'icon-plus' ,title: null, cta: null};
          var subbar = {style : 'subbar-style', returnicon: 'icon-arrow-order' ,title: null, cta: null};
          var self = this;
          if(!this.subFiltersOpened){
            if(type=='destinations') {
              this.subFiltersOpened = subbar;
              this.subFiltersOpened.cta = 'Applica Destinazione'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.setDestinationToApply(self.destinationmob[0],self.destinationmob[1]); self.toggleSubFilters(); };
              this.subFiltersOpened.title = 'Destinazione'; // TODO: trad
            }else if(type=='geocodes'){
              this.subFiltersOpened = bar;
              this.subFiltersOpened.cta = 'Applica'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.initGeocode(); self.toggleSubFilters(); };
              this.subFiltersOpened.title = 'Modifica ricerca'; // TODO: trad
            }else{
              this.subFiltersOpened = bar;
              this.subFiltersOpened.cta = 'Applica'; // TODO: trad
              this.subFiltersOpened.ctaFN = function() { self.applyFilterMob(); self.toggleSubFilters(); };
              this.subFiltersOpened.title = 'Ordina'; // TODO: trad
            }
            this.subFiltersOpened.type = type;
          }else{
            this.subFiltersOpened = false;
          }
        },
        applyFilterMob(name, value, type){
          if (this.mobordine == 'partenza') {
            this.sortKey = 'data_partenza';
            this.sortBy('data_partenza');
          }
          if (this.mobordine == 'prezzo') {
            this.sortKey = 'prezzo';
            this.sortBy('prezzo');
          }
        },applyFilter(name, value, type){
          /*if(name == 'date'){
            this.$refs.datepicker.resetDatepicker(true);
          }*/
          if(!this.matchMedia.lg || type.indexOf('paginationorder')!=-1) {
            this.setApplyFilter([name, value, type]);
          }else{
            this.setApplyFilter([name, value, type, true]);//parametro per non mandare direttamente in esecuzione i filtri
          }
        },
        getAlerts(alert){
          if(Object.keys(this.alerts).length){
            if(this.alerts.indexOf(alert)!=-1)
              return true;
          }
          return false;
        },
        getFilterState(category, name) {
          if(category && name) {
            return this.filtersActive[category] ? this.filtersActive[category].indexOf(name) != -1 : false;
          }
          return false;
        },
        getOrderState(category, name) {
          if(category && name && this.paginationOrderActive[category]) {
            if (category == 'ordinamento') {
              var ret = (name !== this.paginationOrderActive[category].split('_')[0] ? '' : this.paginationOrderActive[category].indexOf('desc') == -1 ? 'asc' : 'desc');
              return name !== this.paginationOrderActive[category].split('_')[0] ? '' : this.paginationOrderActive[category].indexOf('desc') == -1 ? 'asc' : 'desc';
            }else{
             if(category == 'record_per_pagina')
              return this.paginationOrderActive[category] ? this.paginationOrderActive[category].indexOf(name) != -1 : false;
            }
          }
          return '';
        },
        geocodeInput(){
          if(this.geocodeToApply.length)
            this.geocodeToApply = [];

          if (this.timer) {
            clearTimeout(this.timer);
          }
          this.timer = setTimeout(() => {
            if(this.geocodemodel.trim().length>2) {
              this.getResponseAPI({url: 'geocode', param: {q: this.geocodemodel}});
              this.suggestionsdisplay = true;
            }
          }, 1000);
        },

      focusoutSuggestions(){
        setTimeout(() => { this.suggestionsdisplay = false } , 200);
      },

      setGeocodeToApply(geocodeItem){
        this.geocodeToApply = geocodeItem;
        this.geocodemodel = geocodeItem[1];
        if(!this.matchMedia.lg && this.layout==='big') {
          this.setGeocodes({});
        }
      },
      openModal(type, data) {
        this.setModal({
          type: type,
          data: data
        });
      },
      removeAllFilters(){
        //this.$refs.datepicker.resetDatepicker(true);
        this.removeFilters();
      },
      matchMediaFn(){
          var lg = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-lg`)})`);
          var md = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-md`)})`);
          var sm = window.matchMedia(`(max-width: ${getComputedStyle(document.documentElement).getPropertyValue(`--breakpoint-sm`)})`);
          var matchMediaObj = {lg: lg.matches, md: md.matches, sm: sm.matches};
          if(matchMediaObj != this.matchMedia) {
            this.matchMedia = {lg: lg.matches, md: md.matches, sm: sm.matches};
            this.setInfoBreakpoints(this.matchMedia);
          }
      },
      setCookie(cookieName, cookieVal, expDays) {
        var expires = null;
        if(expDays) {
          var date = new Date();
          date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
          const expires = "expires=" + date.toUTCString();
          document.cookie = cookieName + "=" + cookieVal + "; " + expires + "; path=/";
        }else{
          document.cookie = cookieName + "=" + cookieVal + "; path=/";
        }
      },
      getCookie(cookieName) {
        var name = cookieName + "=";
        var cookieDecoded = decodeURIComponent(document.cookie); //to be careful
        var cookies = cookieDecoded.split('; ');
        var res;
        for(var i=0; i<cookies.length;i++) {
          if (cookies[i].indexOf(name) === 0)
            res = cookies[i].substring(name.length);
        }
        return res;
      },
      confirmationModalData(product, userdataraw) {
        var userdata = JSON.parse(userdataraw);
        userdata.specific_input = {
          email: '',
          dati_prodotto: {
            id: product.id,
            preno_cod: product.preno_cod,
            gruppo_cod: product.gruppo_cod,
            cod_guidato: product.cod_guidato,
            cod_sottoprogramma: product.cod_sottoprogramma,
            nome_viaggio: product.nome_viaggio,
            data_partenza: product.data_partenza,
            data_partenza_timestamp: product.data_partenza_timestamp,
            data_ritorno: product.data_ritorno,
            data_ritorno_timestamp: product.data_ritorno_timestamp,
            durata: product.durata,
            prezzo: product.prezzo,
            valuta: product.valuta,
            cod_disponibilita: product.cod_disponibilita,
            url: this.getProductURL(product)
          }
        };
        return userdata;
      },
      formatPrice(price) {
        return price.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.');
      },
      getProductURL(product) {
        return this.producturl+'?pid='+product.cod_guidato+'-'+product.cod_sottoprogramma+'_'+product.data_partenza.slice(0,10);
      }
    },
    components: {},
    created() {
        this.init();
        this.matchMediaFn(); //matchMedia init
        window.addEventListener('resize', this.matchMediaFn);//matchMedia on resize
    },
    mounted: function () {

      var btnPreventivo = document.querySelector('#btn-preventivo-pdpdp');
      if(btnPreventivo)
        btnPreventivo.addEventListener('click', e => {
          if(this.origin == 'PDPDP' && this.elements.length) {
            this.openModal('select-city', {confirmUrl: this.spapurl + '?geonameid_code=' + this.geoname + '&pratica_cod=' + this.elements[0].preno_cod + '&prezzo_base_mezza_doppia=' + this.elements[0].prezzo + '&sottoprogramma_cod=' + this.elements[0].cod_sottoprogramma});
          }
        });



    }
}
</script>
